import { Button, DataSource, Label, Layout, Panel, Switch, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCarrierScorecardProfile extends Layout {
    buttonAddDetail: Button;
    buttonSearchDetails: Button;
    labelDetailHeader: Label;
    profileFieldsPanel: Panel;
    sourceCarrierScorecardDetail: DataSource;
    sourceCarrierScorecardProfile: DataSource;
    switchActive: Switch;
    tableCarrierScorecardProfiles: Table;
    textboxDescription: Textbox;
    textboxProfileName: Textbox;
}
